import { saveAs } from 'file-saver';
import React from 'react';
import { NotificationManager } from 'react-notifications';
import LzOptionModel from '../models/option';
import { setLastErrorMessage, setMediaBrowser } from '../redux/actions';

export const lzGetAssetUrl = (path) => {
  return path;
};

export const lzGetFormattedAmount = (value, allowDecimals, stripSymbol, keepDecimal00) => {
  const input = allowDecimals ? value : Math.round(value);

  let output = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  })
    .format(input);

  if (!keepDecimal00) {
    output = output.replace('.00', '');
  }

  if (stripSymbol) {
    return output.replace(/[a-z]/gi, '').trim();
  }

  return output;
};

export const lzGetOptionsFromHashArray = (hash) => {
  const out = [];

  for (const key in hash) {
    out.push(new LzOptionModel({ value: key, text: hash[key] }));
  }

  return out;
};

export const lzLogInfo = (...args) => {
  // args.unshift('LZ-LOG-INFO');
  // console.log(...args);
};

export const lzDownloadBlobFile = (blob, filename) => {
  saveAs(blob, filename);
};

export const lzValueTagsDisplay = (val) => {
  let out = '<small><b>{site-base-url}</b>';

  if (val) {
    out += ', <b>{' + val.split(',').join('}</b>, <b>{') + '}</b>';
  }

  out += '<br/>use above place holders where you want to display respective data in subject and body</small>';

  return out;
};

export const lzShowErrorMessage = (msg) => {
  // Get dispatch from redux store
  const reduxDispatch = window.reduxStore.dispatch;

  reduxDispatch(setLastErrorMessage(msg));
  NotificationManager.error(msg, 'Yikes!', 5000);
};

export const lzShowSuccessMessage = (msg) => {
  NotificationManager.success(msg, 'Hooray!', 3000);
};

export const lzSortByPosition = (objOfObjs, sortKey) => {
  const order = [], res = {};

  // TODO: Need to fix here, if sortOrder of two items is same then it overwrites it to a single item

  Object.keys(objOfObjs).forEach(key => {
    return order[objOfObjs[key][sortKey] - 1] = key;
  });

  order.forEach(key => {
    res[key] = objOfObjs[key];
  });

  return res;
};

export const lzBytesToSize = (bytes) => {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

export const lzShowMediaBrowser = (params, successCallback, failureCallback) => {
  const reduxDispatch = window.reduxStore.dispatch;
  reduxDispatch(setMediaBrowser({
    params: params,
    successCallback: typeof successCallback === 'function' ? successCallback : (media) => console.log('MEDIA-SELECTED', media),
    failureCallback: typeof failureCallback === 'function' ? failureCallback : (msg => console.error('FAILED-UPLOAD', msg)),
  }));
};

export const lzHideMediaBrowser = () => {
  const reduxDispatch = window.reduxStore.dispatch;
  reduxDispatch(setMediaBrowser(null));
};

export const lzGetRange = (min, max) => {
  const size = max - min + 1;

  // console.log('lzGetRange()', min, max, size);

  return [...Array(size).keys()].map(i => i + min);
};

/**
 * Repeat a jsx element n times.
 * 
 * @param {*} jsx 
 * @param {*} times 
 * 
 * @returns jsx
 */
export const lzRepeatJSX = (jsx, times) => new Array(times).fill(0).map((_, dex) => <React.Fragment key={'rr-' + dex}>{jsx}</React.Fragment>);
